import * as ngCore from '@angular/core'
import { MatTooltip } from '@angular/material/tooltip'

/**
 * Tooltip directive that is wrapping {@link MatTooltip} directive from angular
 * material.
 *
 * **Inputs**
 * atnDsTooltip - text in the tooltip to be shown
 *
 * @example
 * ```html
 *  <button atnDsTooltip="Custom tooltip" >
 *    Test button
 *  </button>
 */
@ngCore.Directive({
  hostDirectives: [
    {
      directive: MatTooltip,
      inputs: [
        'matTooltip: atnDsTooltip',
        'matTooltipPosition: atnDsTooltipPosition',
      ],
    },
  ],
  inputs: ['matToolTip'],
  selector: '[atnDsTooltip]',
  standalone: true,
})
export class AtnDsTooltipDirective {}
